
<email-header></email-header>
<div class="main-wrapper">
  <div class="content">
    <div class="container">
      <flight-search [componentType]="'request'"></flight-search>
    </div>
  </div>
</div>
<app-navigation></app-navigation>